import { render, staticRenderFns } from "./IPHistoryCard.vue?vue&type=template&id=70661c3a&scoped=true"
import script from "./IPHistoryCard.vue?vue&type=script&lang=js"
export * from "./IPHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./IPHistoryCard.vue?vue&type=style&index=0&id=70661c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70661c3a",
  null
  
)

export default component.exports